<template>
  <div class="container">
    <div class="user-rank">
      <div class="row align-items-center justify-content-between">
        <div class="col-md-8 mb-4 mb-md-0">
          <UserProfileIntroducingCard :user="user"/>
        </div>

        <div class="col-md-3">
          <div class="user-rank__certificates">
            <div
              v-for="certificate in user.certificates"
              :key="certificate.id"
              class="user-rank__certificates__item"
            >
              <CourseCourseCertificateMiniItem :course="certificate.course"/>
            </div>

            <TextButton @click="showUserCertificates">ver todos</TextButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import UserProfileIntroducingCard from '@/components/user/profile/UserProfileIntroducingCard'
import CourseCourseCertificateMiniItem from '@/components/course/CourseCourseCertificateMiniItem'
import TextButton from '@/components/buttons/TextButton'

export default {
  components: {
    UserProfileIntroducingCard,
    CourseCourseCertificateMiniItem,
    TextButton,
  },

  props: {
    user: { type: Object, required: true }
  },

  methods: {
    ...mapActions('slideSidebar', ['slideSidebarShow']),

    showUserCertificates () {
      this.slideSidebarShow({
        name: 'user/UserCertificatesSidebar',
        direction: 'right',
        props: { user: this.user }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .user-rank {
    padding: 24px;
    border-radius: 8px;
    border: 1px solid #FFFFFF1A;
    background: $purple50;

    ::v-deep .profile { padding: 0 }

    &__certificates {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      // justify-content: space-evenly;
      // align-items: flex-start;

      & > * {
        flex: 0 0 33.3%;

        &:not(:last-child) {
          display: flex;
          justify-content: center;
          margin-bottom: 11px;
        }
      }

      & > *:last-child { 
        flex: 0 0 50%;
        margin-top: 16px;
      }
    }
  }

  @media (max-width: 992px) {
    .container {
      padding: 0;
    }

    .user-rank {
      padding: 15px;

      ::v-deep {
        .profile__avatar { 
          width: 60px; height: 60px;
        }
        
        .profile__user__name { 
          font-size: 18px;
        }
      }
    }
  }
</style>